// extracted by mini-css-extract-plugin
export default {"error":"styles_error__HkEr3","login":"styles_login__BeD1A"};